<script>
import { ref, onMounted } from 'vue';
import { useI18n } from 'vue-i18n'
import { useModalStore } from '@/stores/modal.js'
import SkeletonLoader from '@/components/ui/skeleton_loader.vue'

export default {
  components: { SkeletonLoader },
  setup() {
    // I18n
    const { t } = useI18n()

    const modalStore = useModalStore()
    const isLoading = ref(true)

    onMounted(() => {
      setTimeout(() => {
        isLoading.value = false
      }, 500)
    })

    const buyPackage = async (package_id) => {
      modalStore.currentStripeProduct = package_id;
      modalStore.setModal(modalStore.modalTypeConstants.STRIPE_PAYMENT)
    }

    // Quote packages data
    const quotePackages = ref([
      {
        title: t('settings.orders.packages.three_quotes_title'),
        description: 'Ideal if you’ve got a few upcoming repairs or maintenance items in mind.',
        price: '5',
        type: t('settings.orders.packages.one_time_purchase'),
        theme: "white",
        package_id: "3quotes",
      },
      {
        title: t('settings.orders.packages.five_quotes_title'),
        description: 'Planning ahead? Get quotes for multiple services - when and where you need them.',
        price: '7',
        type: t('settings.orders.packages.one_time_purchase'),
        theme: "white",
        package_id: "5quotes",
      }
    ])

    const handleHover = (index, event) => {
      quotePackages.value.forEach((quotePackage, i) => {
        if (i === index) {
          quotePackage.theme = event.type === 'mouseenter' ? 'primary' : 'white';
        } else {
          quotePackage.theme = 'white';
        }
      });
    }

    return {
      t,
      isLoading,
      quotePackages,
      handleHover,
      buyPackage
    }
  }
}
</script>

<template>
  <div class="vh-screen flex flex-col">
    <div v-if="!isLoading" class="font-sans min-h-screen p-8">
      <h1 class="text-3xl font-semibold mb-4">{{ t('settings.orders.title') }}</h1>
      <hr/>

      <div class="flex items-center gap-8 mt-6 flex-wrap md:flex-nowrap">
        <div v-for="(quote_package, index) in quotePackages" :key="`quotepackage-${index}`" class="">
          <div @mouseenter="handleHover(index, $event)" @mouseleave="handleHover(index, $event)" :class="`${quote_package.theme === 'primary' ? 'bg-gray-800 text-white' : 'bg-gray-200'} rounded-lg shadow-md p-6 w-full md:w-96 flex flex-col items-center package-card`">
            <h2 :class="`${quote_package.theme === 'primary' ? 'text-white' : 'text-gray-800'} text-2xl font-semibold mb-2`">{{ quote_package.title }}</h2>
            <p :class="`${quote_package.theme === 'primary' ? 'text-white' : 'text-gray-600'} text-sm text-center mb-6`">{{ quote_package.description }}</p>
            <div :class="`${quote_package.theme === 'primary' ? 'text-white' : 'text-gray-900'} text-[10rem] font-bold mb-2 flex items-center mt-[-2rem]`">
              <span class="text-3xl mb-24 mr-1 mt-[-3rem]">$</span>{{ quote_package.price }}
            </div>
            <p :class="`${quote_package.theme === 'primary' ? 'text-white' : 'text-gray-500'} mb-8 mt-[-3rem]`">{{ quote_package.type }}</p>
            <button @click="buyPackage(quote_package.package_id)" :class="[quote_package.theme === 'primary' ? 'bg-white text-black' : 'bg-gray-800 text-white', 'font-bold py-2 px-6 rounded-md mb-4 w-full']">
              {{ t('settings.orders.buy_button') }}
            </button>
            <div class="flex items-center text-gray-500 text-sm">
              <span :class="`${quote_package.theme === 'primary' ? 'text-white' : 'text-gray-500'} text-xs mt-2`">{{ t('settings.orders.payment_card_padlock') }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-12 max-w-2xl text-gray-700">
        <h3 class="text-lg font-semibold mb-2">{{ t('settings.orders.security_affirmation_title') }}</h3>
        <p class="text-sm">
          {{ t('settings.orders.we_use_stripe_text') }}
          <a class="font-medium underline" href="https://stripe.com/" target="_blank">Stripe</a>
          {{ t('settings.orders.we_use_stripe_text_2') }}
        </p>
      </div>
    </div>
    <div v-else class="p-8">
      <SkeletonLoader type="default" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@/assets/styles/views/settings/orders';
</style>
